import Keycloak from "keycloak-js";
import { AxiosRequestConfig } from "axios";

export const TOKEN_KEY = "@bnb-Auth-Token";
export const keycloak = Keycloak(process.env.PUBLIC_URL + "/keycloak.json");
export const getToken = () => keycloak.token;
export const isAuthenticated = () => keycloak.token !== null && keycloak.token !== undefined;

export const init = (onload: any, flow: any) => {
	return keycloak.init({ onLoad: onload, flow, checkLoginIframe: false });
};

export const logout = () => {
	keycloak.logout({
		redirectUri: process.env.REACT_APP_API_REDIRECT || "http://localhost:3000",
	});
};

export function setHeaderOnConfig(config: AxiosRequestConfig) {
	config.headers.Authorization = `Bearer ${keycloak.token}`;
	return config;
}

keycloak.onTokenExpired = () => {
	keycloak
		.updateToken(40)
		.success((hasRefreshed) => {
			if (hasRefreshed && keycloak.token !== undefined) {
				sessionStorage.setItem("token", keycloak.token);
			} else {
				logout();
			}
		})
		.error((hasError) => {
			logout();
		});
};
